import React from 'react';
import { View, StyleSheet } from 'react-native';
import { useTheme } from '../../contexts/ThemeContext';
import { Skeleton } from '../Skeleton';

export default function CalendarSkeleton() {
  const { colors } = useTheme();

  return (
    <View style={[styles.container, { backgroundColor: colors.card, borderColor: colors.cardBorder }]}>
      {/* Header skeleton */}
      <View style={styles.header}>
        <Skeleton width={140} height={20} borderRadius={4} />
        <Skeleton width={200} height={32} borderRadius={8} />
        <Skeleton width={160} height={32} borderRadius={8} />
      </View>

      {/* Day headers skeleton */}
      <View style={styles.dayHeaders}>
        {Array.from({ length: 7 }).map((_, i) => (
          <View key={i} style={styles.dayHeaderSkeleton}>
            <Skeleton width={32} height={12} borderRadius={4} />
            <Skeleton width={24} height={24} borderRadius={12} />
          </View>
        ))}
      </View>

      {/* Grid rows skeleton */}
      {Array.from({ length: 6 }).map((_, i) => (
        <View
          key={i}
          style={[styles.gridRow, { borderBottomColor: colors.divider }]}
        >
          <Skeleton width={36} height={12} borderRadius={4} />
          <View style={styles.gridCells}>
            {i === 0 && <Skeleton width="70%" height={50} borderRadius={8} style={styles.eventSkeleton} />}
            {i === 2 && <Skeleton width="50%" height={30} borderRadius={8} style={styles.eventSkeleton} />}
            {i === 4 && <Skeleton width="30%" height={50} borderRadius={8} style={styles.eventSkeleton} />}
          </View>
        </View>
      ))}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    borderRadius: 12,
    borderWidth: 1,
    padding: 16,
    gap: 12,
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingBottom: 12,
  },
  dayHeaders: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    paddingBottom: 8,
  },
  dayHeaderSkeleton: {
    alignItems: 'center',
    gap: 4,
  },
  gridRow: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    borderBottomWidth: 1,
    paddingVertical: 12,
    height: 70,
    gap: 12,
  },
  gridCells: {
    flex: 1,
    flexDirection: 'row',
  },
  eventSkeleton: {
    marginTop: 4,
  },
});
